import React from "react";
import { motion } from "framer-motion";
import {
  FaEdit,
  FaMapMarkerAlt,
  FaShoppingCart,
  FaCreditCard,
  FaHeart,
} from "react-icons/fa";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const UserProfile = () => {
  const user = {
    name: "John Doe",
    email: "johndoe@example.com",
    phone: "+1 234 567 890",
    profilePic: "https://via.placeholder.com/150",
    address: [
      { type: "Home", details: "123 Main Street, Surrey, BC, V3R 4X5" },
      { type: "Office", details: "456 Business Ave, Vancouver, BC, V5K 2N1" },
    ],
    orders: [
      { id: "#12345", date: "Feb 10, 2024", status: "Delivered", total: "$150.00" },
      { id: "#67890", date: "Jan 28, 2024", status: "Processing", total: "$200.00" },
    ],
    wishlist: ["Blackout Blinds", "Motorized Shades", "Wooden Venetian Blinds"],
    paymentMethods: [
      { type: "Visa", last4: "4242" },
      { type: "MasterCard", last4: "5678" },
    ],
    loyaltyPoints: 1200,
  };

  return (
    <>
    <Navbar/>
    <motion.div
      className="max-w-6xl mx-auto lg: pt-20 p-8 bg-white shadow-xl rounded-lg mt-8 border border-gray-300"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Profile Section */}
      <motion.div className="flex flex-col md:flex-row items-center p-6 border-b">
        <img
          src={user.profilePic}
          alt="Profile"
          className="w-28 h-28 rounded-full border-4 border-blue-500 shadow-lg"
        />
        <div className="ml-6 text-center md:text-left">
          <h3 className="text-3xl font-bold text-gray-900">{user.name}</h3>
          <p className="text-gray-700">{user.email}</p>
          <p className="text-gray-700">{user.phone}</p>
          <button className="mt-4 px-5 py-2 bg-blue-600 text-white rounded-lg flex items-center gap-2 hover:bg-blue-700">
            <FaEdit /> Edit Profile
          </button>
        </div>
      </motion.div>

      {/* Order Tracking Section */}
      <motion.div className="mt-6 p-4 border-b">
        <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
          <FaShoppingCart /> Order Tracking
        </h3>
        {user.orders.map((order) => (
          <div
            key={order.id}
            className="flex justify-between items-center p-4 border rounded-lg mb-3 bg-gray-100 shadow-sm"
          >
            <div>
              <p className="font-medium">Order {order.id}</p>
              <p className="text-sm text-gray-600">{order.date}</p>
            </div>
            <span
              className={`px-4 py-1 rounded-full text-white ${
                order.status === "Delivered" ? "bg-green-500" : "bg-yellow-500"
              }`}
            >
              {order.status}
            </span>
            <p className="font-medium text-blue-700">{order.total}</p>
          </div>
        ))}
      </motion.div>

      {/* Address Section */}
      <motion.div className="mt-6 p-4 border-b">
        <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
          <FaMapMarkerAlt /> Saved Addresses
        </h3>
        <div className="grid md:grid-cols-2 gap-5">
          {user.address.map((addr, index) => (
            <div
              key={index}
              className="p-5 border rounded-lg bg-gray-50 shadow flex justify-between items-center"
            >
              <div>
                <p className="font-medium text-gray-900">{addr.type} Address</p>
                <p className="text-gray-700">{addr.details}</p>
              </div>
              <button className="text-blue-600 hover:text-blue-800">
                <FaEdit />
              </button>
            </div>
          ))}
        </div>
      </motion.div>

      {/* Payment Methods Section */}
      <motion.div className="mt-6 p-4 border-b">
        <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
          <FaCreditCard /> Payment Methods
        </h3>
        {user.paymentMethods.map((method, index) => (
          <div
            key={index}
            className="flex justify-between items-center p-4 border rounded-lg mb-3 bg-gray-100 shadow-sm"
          >
            <p className="font-medium">{method.type} - **** {method.last4}</p>
            <button className="text-blue-600 hover:text-blue-800">
              <FaEdit />
            </button>
          </div>
        ))}
      </motion.div>

      {/* Wishlist Section */}
      <motion.div className="mt-6 p-4 border-b">
        <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
          <FaHeart /> Wishlist
        </h3>
        <ul className="list-disc pl-6">
          {user.wishlist.map((item, index) => (
            <li key={index} className="text-gray-800">{item}</li>
          ))}
        </ul>
      </motion.div>

      {/* Loyalty Points */}
      <motion.div className="mt-6 p-4">
        <h3 className="text-xl font-semibold mb-4">Loyalty Points</h3>
        <p className="text-gray-800">
          Available Points: <span className="font-bold text-green-600">{user.loyaltyPoints}</span>
        </p>
      </motion.div>
    </motion.div>

    <Footer/>
    </>
  );
};

export default UserProfile;
